module.exports = __webpack_public_path__ + "c51e650daca1e5879197fdc00fe57e87.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/v.png
// module id = 225
// module chunks = 0